import type { Slide as EditorSlide } from '@mentimeter/editor-schema/api-types-overrides';
import type { Question } from '../../../legacy-series-types';
import { UnsupportedSlidePropertyError } from '../../../backward-compatibility/errors/unsupported-slide-property-error';

export const mapEditorQuestionPropertyToSlideProperty = (
  slide: EditorSlide,
  key: keyof Question,
) => {
  switch (key) {
    case 'has_comments':
      return slide.hasComments;

    default:
      if (process.env.NODE_ENV === 'development') {
        const error = new UnsupportedSlidePropertyError(key);
        // eslint-disable-next-line no-console
        console.warn(error.message);
      }

      return undefined;
  }
};
